<template>
  <div>
    <validation-observer
      tag="form"
      ref="commentManagementRef"
      novalidate
      v-if="!isCaseResolved"
    >
      <div class="row p-4">
        <div class="col-12">
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-text-area
              :label="`${$t('lbltxtComment.text')}:`"
              :maxlength="3000"
              :count-classes="['d-block text-right color-gray-6']"
              show-char-count
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="$t('RequiredField')"
            />
          </validation-provider>
        </div>
        <div class="col-12 text-right mt-2">
          <action-button
            :text="$t('btCancel.Text')"
            class="warning outline-warning px-4 py-2 mr-2"
            i="fa fa-times-circle"
            @click="onCancelHandler"
          />
          <action-button
            :text="$t('Save')"
            class="btn-success px-4 py-2 mr-2"
            i="fa fa-plus-circle"
            @click="addCommentHandler"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//libs
import CustomTextArea from '@/components/common/CustomTextArea.vue';
import ActionButton from 'ActionButton';

//services
import { addRequestComment as _addRequestComment } from '@/services/app.api';

//mixins
import alertMixin from 'utils/mixins/alert.mixin';
import { userMixin } from '@/mixins/user.mixin';
import { i18n } from '@/i18n';

export default {
  name: 'CommentManagement',
  mixins: [alertMixin, userMixin],
  components: {
    CustomTextArea,
    ActionButton,
  },
  data() {
    return {
      model: {
        comment: null,
      },
    };
  },
  computed: {
    requestNumber() {
      return this.itemModel?.requestNumber;
    },
  },
  async mounted() {},
  methods: {
    onCancelHandler() {
      this.model = {};
      this.setIsNavOpen({
        isNavOpen: false,
        navOption: {},
      });
    },
    async addCommentHandler() {
      const isValid = await this.$refs.commentManagementRef.validate();
      if (!isValid || this.isUserEmpty) {
        this.ShowToast(
          i18n.t('Alert'),
          `${i18n.t('PleaseCompleteRequestedInformation')}.`,
          'error'
        );
        return;
      }
      const { comment } = this.model;
      if (this.requestNumber && comment) {
        const { data } = await _addRequestComment(this.requestNumber, comment);
        if (data) {
          this.ShowToast(
            i18n.t('ProcessSuccessfully'),
            i18n.t('CommentAddedSuccessfully'),
            'success'
          );
          this.model = {};
          this.$refs.commentManagementRef.reset();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
@import '@/scss/components/action-button/index.scss';

.comment-panel {
  height: calc(100vh - 400px);
  overflow-y: auto;
  .actions-container {
    display: inline-flex;
    align-items: center;
    .action-button__extended ::v-deep {
      display: inline-flex;
      margin-right: 1rem;
      padding: 0.4rem;
      .fa {
        margin: 0 !important;
      }
    }
  }
}

.delete-comment-icon {
  cursor: pointer;
  color: map-get($colors, 'orange');
}

.custom-balloon__extended {
  min-width: 10rem;
  width: fit-content !important;
  font-size: 1rem !important;
  padding: 0.25rem 1rem !important;
  margin-left: 0 !important;
}
@media only screen and (max-width: 768px) {
  .custom-balloon__extended ::v-deep {
    display: inline !important;
    padding: 5px 20px !important;
    margin-left: 0px !important;
  }
}
</style>
